import { useMemo } from "react";
import * as Toggle from "@radix-ui/react-toggle";
import { TIMELINE_DEFAULT_HOUR_WIDTH, TIMELINE_PADDING } from "@opstel/SBD/core/layoutConstants";
import { BlockedDuration } from "@opstel/query/models/track";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import classNames from "classnames";

export interface SBDDisabledTrackProps {
  readonly blockedDuration: BlockedDuration;
  readonly zoomLevel: number;
}

export function SBDDisabledTrack({ blockedDuration, zoomLevel }: SBDDisabledTrackProps) {
  const scenarioStart = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const { startTime, endTime } = blockedDuration;

  const { drawStartTimeInHours, drawDurationInHours } = useMemo(() => {
    const drawStartTimeInHours = startTime.diff(scenarioStart).as("hours");
    const drawDurationInHours = endTime.diff(startTime).as("hours");
    return { drawStartTimeInHours, drawDurationInHours };
  }, [startTime, endTime, scenarioStart]);

  const width = drawDurationInHours * TIMELINE_DEFAULT_HOUR_WIDTH * zoomLevel;
  const left = drawStartTimeInHours * TIMELINE_DEFAULT_HOUR_WIDTH * zoomLevel;
  return (
    <Toggle.Root
      className={classNames(
        "absolute inset-y-0 z-8 flex items-center gap-1 border-0",
        "before:absolute before:inset-0 before:content-[''] hover:before:bg-hover",
        "focus:outline-2 focus:outline-purple-400 focus:outline-solid",
      )}
      style={{
        left: `${TIMELINE_PADDING + left}px`,
        width: `${width}px`,
        background: `repeating-linear-gradient(
          -60deg,
          var(--background-color-alpha-subtle),
          var(--background-color-alpha-subtle) 10px,
          var(--background-color-alpha-default) 10px,
          var(--background-color-alpha-default) 20px
        )`,
      }}
      aria-label={`Buiten dienst van ${startTime.toFormat("ccc HH:mm:ss")} tot ${endTime.toFormat("ccc HH:mm:ss")}`}
    />
  );
}
